import { render, staticRenderFns } from "./EditServiceSideBarDates.vue?vue&type=template&id=c6d7ef4c&"
import script from "./EditServiceSideBarDates.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports